import { deleteAllObj, deleteObj } from "../helpers/deleteAllObj";
import { loadGLB } from "../helpers/loadGLB";
import { setVis } from "../helpers/setVis";
import { saveAllCheckedInputsInUserData } from "./addProductCard";
import { calculator, restoreCalcActives } from "./calculator";
import { changeMaterialColor } from "./changeMaterialColor";
import { changeTableColor } from "./changeObjectParams/changes/tables/down/down";
import { showHideChildrenByNames } from "./changeObjectParams/helpers";
import { cloneObject } from "./cloneObject";
import { openCorrectSideMenu } from "./dynamicLoader";
import { loadElementiForTables } from "./loadElementiForTables/loadElementiForTables";
import { setIntersectsObjects } from "./raycaster";
import { applyRoomLighting } from "./scene";
import { setCameraOnEditMode, setCameraOnRoom } from "./setUpCamera";
import * as THREE from "three";
import { cardItems } from "./vars/cardItems";
import { addObjectToScene } from "./addObjectToScene";
import { getTableName } from "../helpers/getTableName";
import { LOAD_DATA } from "./changeObjectParams/changes/wardrobes/changeKomplektatsia";

export const createObjToSave = async () => {
    const servObj = window.servObj || parent.servObj;
    const isEditMode = servObj.isRedactorMode;
    const getObjData = ({ position: { x, y, z }, userData, name, scale, children }) => {
        const meshes = children
            .filter((mesh) => mesh.isMesh)
            .map((mesh) => ({
                name: mesh.name,
                position: {
                    x: mesh.position.x,
                    y: mesh.position.y,
                    z: mesh.position.z,
                },
            }));

        return {
            position: {
                x,
                y,
                z,
            },
            userData,
            name,
            scale,
            meshes,
        };
    };
    if (isEditMode) {
        saveAllCheckedInputsInUserData();
        const table = [getObjData(servObj.redactorModeObject)];

        const elements = Object.entries(servObj)
            .filter(
                ([key, value]) =>
                    key.startsWith("active") &&
                    !key.includes("activeTableBazovii") &&
                    key !== "activeHitbox" &&
                    Array.isArray(value) &&
                    value.length > 0,
            )
            .flatMap(([, arr]) => arr.map(getObjData));
        const colors = servObj.tableColor;

        return {
            isEditMode,
            table,
            elements,
            colors,
        };
    } else {
        const buildingInfo = servObj.building.buildingInfo;
        const columnsData = servObj.building.columnsData;
        const allTableInRoom = servObj.building._objects;

        // Преобразуем allTableInRoom в массив JS-объектов
        const tables = allTableInRoom.map((parent) => {
            const parentObj = {
                position: {
                    x: parent.position.x,
                    y: parent.position.y,
                    z: parent.position.z,
                },
                rotation: {
                    x: parent.rotation.x,
                    y: parent.rotation.y,
                    z: parent.rotation.z,
                },
                name: parent.name,
                userData: parent.userData,
                meshes: parent.children
                    .filter((mesh) => mesh.isMesh)
                    .map((mesh) => ({
                        name: mesh.name,
                        position: {
                            x: mesh.position.x,
                            y: mesh.position.y,
                            z: mesh.position.z,
                        },
                    })),
                elements: [],
            };

            // Добавляем элементы-children, если они группы
            parentObj.elements = parent.children
                .filter(
                    (child) =>
                        (child.isGroup || (child.isObject3D && child.type === "Object3D")) && !child.isCSS2DObject,
                )
                .map((child) => ({
                    position: {
                        x: child.position.x,
                        y: child.position.y,
                        z: child.position.z,
                    },
                    rotation: {
                        x: child.rotation.x,
                        y: child.rotation.y,
                        z: child.rotation.z,
                    },
                    scale: {
                        x: child.scale.x,
                        y: child.scale.y,
                        z: child.scale.z,
                    },
                    name: child.name,
                    userData: child.userData,
                    visible: child.visible,
                }));
            return parentObj;
        });
        return {
            buildingInfo,
            columnsData,
            tables,
        };
    }
};
export const saveJSON = (obj, fileName = "no name") => {
    const json = JSON.stringify(obj);
    const blob = new Blob([json], {
        type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
const getHiddenObjArr = (name) => {
    if (name.includes("osveshchenie")) return ["hitbox", "razdelitel", "ogranichitel", "instrumentalnaya_planka"];
    if (name.includes("razdeliteli")) return ["hitbox", "osveshchenie", "ogranichitel"];
    if (name.includes("ogranichitel") && !name.includes("bokovoi") && !name.includes("zadnii"))
        return ["hitbox", "osveshchenie", "razdeliteli"];
    if (name.includes("ogranichitel_bokovoi")) return ["hitbox", "osveshchenie", "razdelitel"];
    if (name.includes("ogranichitel_zadnii")) return ["hitbox", "osveshchenie", "razdelitel"];
    if (name.includes("instrumentalnaya_planka")) return ["derzhatel_ruchnogo_instrumenta"];
    if (name.includes("polka_pribornaya")) return ["osveshchenie_pod_pribornuyu"];
    if (name.includes("dopolnitelniy_derzhatel")) return ["bokovoy_fiksator_rulona"];
    if (name.includes("komplekt_stoek")) return ["krepleniya"];
    if (name.includes("tumba_podvesnaya")) return ["__key"];
    if (name.includes("polka_nizhnyaya__dsp")) return ["razdelitel__polka_nizhnyaya__dsp"];
    return ["hitbox", "razdeliteli", "ogranichitel", "fiksatori", "bolt_", "dopolnitelnoe_pokritie_polok"];
};
export const loadJSON = async (loadedObj) => {
    const { isEditMode, table, elements, colors, buildingInfo, columnsData, tables } = loadedObj;
    isEditMode ? deleteObj(servObj.redactorModeObject) : deleteAllObj();
    calculator();
    const addInRoomBtn = document.querySelector(".add_in_room_btn_wrap");
    const animateDoorsBtnWrap = document.querySelector(".animate-doors_btn_wrap");

    if (isEditMode) {
        const currentTable = table[0];
        const { userData } = currentTable;
        const { defaultSize, loadData } = userData;

        loadData.defaultSize = defaultSize;
        const calcTableName = getTableName(loadData);
        await addObjectToScene(loadData, calcTableName, true);
        servObj.redactorModeObject.userData = userData;
        servObj.targetPageKey = loadData.folderName;

        const { meshes } = currentTable;
        console.log({ meshes, elements });

        meshes?.length &&
            meshes.forEach((meshData) => {
                const mesh = servObj.redactorModeObject.getObjectByName(meshData.name);
                if (mesh && mesh.isMesh) {
                    mesh.position.set(meshData.position.x, meshData.position.y, meshData.position.z);
                }
            });

        elements.forEach((element) => {
            const { position, userData, scale } = element;
            const { name, activeFolderName, allFolderName, verticalOnly, horizontalOnly, inputCount, visibleChildren } =
                userData;
            const originalElement = servObj[allFolderName].find((el) => el.name.includes(name));
            if (!originalElement) {
                console.warn("Объект с именем " + name + " не найден");
                return;
            }

            const cloneElement = cloneObject(originalElement);
            Object.assign(cloneElement.position, position);
            Object.assign(cloneElement.scale, scale);
            cloneElement.userData = {
                ...cloneElement.userData,
                ...userData,
            };
            servObj[activeFolderName].push(cloneElement);
            servObj.scene.add(cloneElement);
            setVis(cloneElement, true);
            showHideChildrenByNames(cloneElement, getHiddenObjArr(name), false);
            cloneElement.children?.forEach((el) => {
                el.name.includes("hitbox") && servObj.activeHitbox.push(el);
                showHideChildrenByNames(cloneElement, getHiddenObjArr(el.name), false);
            });
            if (visibleChildren?.length) {
                showHideChildrenByNames(cloneElement, visibleChildren, true);

                cloneElement.traverse((subChild) => {
                    if (subChild?.isGroup) {
                        const hiddenArr = getHiddenObjArr(subChild.name)?.filter((el) => {
                            // Проверяем: если в visibleChildren есть строка, которая ВКЛЮЧАЕТ в себя краткое имя el,
                            // то возвращаем false (не добавляем в список на скрытие)
                            return !visibleChildren.some((v) => v.includes(el));
                        });

                        showHideChildrenByNames(cloneElement, hiddenArr, false);
                    }
                });
            }
            if (verticalOnly) {
                const compareKeys = inputCount ? ["type", "name", "inputCount"] : ["type", "name"];
                const newUserData = userData;
                servObj.building._vertical_only = servObj.building._vertical_only.filter((el) => {
                    // Если хотя бы один из ключей отсутствует — не удаляем элемент
                    if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                        return true;
                    }
                    // Если все ключи совпадают — удаляем элемент
                    return !compareKeys.every((key) => el.userData[key] === newUserData[key]);
                });
                servObj.building.addVerticalObj(cloneElement);
                servObj.building.restoreObjectColor();
                setTimeout(() => {
                    servObj.building.checkCollision();
                }, 100);
            }
            if (horizontalOnly) {
                const compareKeys = inputCount ? ["type", "name", "inputCount"] : ["type", "name"];
                const newUserData = userData;
                servObj.building._horizontal_only = servObj.building._horizontal_only.filter((el) => {
                    // Если хотя бы один из ключей отсутствует — не удаляем элемент
                    if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                        return true;
                    }
                    // Если все ключи совпадают — удаляем элемент
                    return !compareKeys.every((key) => el.userData[key] === newUserData[key]);
                });
                servObj.building.addHorizontalObj(cloneElement);
                servObj.building.restoreObjectColor();
                setTimeout(() => {
                    servObj.building.checkCollision();
                }, 100);
            }
        });
        const { changeable_kromka_material, changeable_painted_metal_material } = colors;
        changeTableColor("changeable_kromka_material", changeable_kromka_material.current);
        changeTableColor("changeable_painted_metal_material", changeable_painted_metal_material.current);

        // ОБНОВИМ СЧЁТЧИК ЦЕНЫ
        restoreCalcActives();

        // ОТКРОЕМ КОРРЕКТНОЕ БОКОВОЕ МЕНЮ
        const { glbName, folderName, typeName, wardrobeType } = loadData;

        console.log({ folderName, typeName, loadData });

        const key = typeof loadData.name === "string" ? loadData.name : loadData.objectName;
        
        const isInstrumentalniyShkaf = loadData.wardrobeType && ["shi", "ship", "shir", "shio"].includes(loadData.wardrobeType);

        let targetCard = null;
        
        if (isInstrumentalniyShkaf) {
            targetCard = LOAD_DATA[wardrobeType];
        } else {
            targetCard = cardItems[folderName][typeName].find((el) => el.glbName === glbName);
        }

        const [name, type] = servObj.redactorModeObject.name.split("__");
        const folder = servObj.redactorModeObject.userData.loadData.folderName;
        const specialFolders = ["stoli_podkatnie", "telezhki", "tumbi", "stellazhi", "stulya", "verstaki", "wardrobes"];

        servObj.tempName = specialFolders.includes(folder) ? type : `${name}__${type}`;
        
        if (isInstrumentalniyShkaf) servObj.tempName = "instrumentalniy";

        if (targetCard) {
            const { nextMenu, menuTitle } = targetCard;
            await openCorrectSideMenu(nextMenu, menuTitle);
        }

        setCameraOnEditMode(servObj.redactorModeObject, false);
        const visibleChildren = servObj.redactorModeObject.userData?.visibleChildren;
        if (visibleChildren?.length) {
            showHideChildrenByNames(servObj.redactorModeObject, visibleChildren, true);
        }
    } else {
        if (buildingInfo) {
            const { width, depth, height, wallColor, floorColor } = buildingInfo;
            setRoomSizes({
                width,
                depth,
                height,
            });
            servObj.building.changeWallsColor(wallColor);
            servObj.building.changeFloorColor(floorColor);
        }
        if (columnsData?.length) {
            servObj.building._all = servObj.building._all.filter((el) => el.name !== "column");
            columnsData.forEach((column) => {
                const { position, rotation, scale } = column;
                const rot = new THREE.Euler(rotation.x, rotation.y, rotation.z, "XYZ");
                servObj.building.addColumn(scale.x, scale.z, position, rot);
            });
        }

        if (tables?.length) {
            for (const tableObj of tables) {
                const { position, rotation, userData, elements, meshes } = tableObj;
                const tableName = userData.name;
                const { glbName } = userData.loadData;
                // Пытаемся найти стол на сцене по имени
                let table = servObj.scene.getObjectByName(tableName);
                // Если не найден, загружаем через loadGLB
                if (!table) {
                    const glb = await loadGLB(userData.loadData);
                    // Ищем стол в загруженном glb
                    table = glb.children.find((obj) => obj.name === tableName);

                    // Грузим элементы для этого стола
                    await loadElementiForTables(glbName, glb);
                    if (!table) {
                        console.warn("Стол не найден после загрузки GLB:", tableName);
                        continue;
                    }
                }
                const newTable = cloneObject(table);
                // Применяем позицию, вращение, userData
                newTable.position.set(position.x, position.y, position.z);
                newTable.rotation.set(rotation.x, rotation.y, rotation.z);
                newTable.userData = {
                    ...newTable.userData,
                    ...userData,
                };

                // Приводим userData.bSize к THREE.Vector3, если есть
                if (newTable.userData && newTable.userData.bSize) {
                    const bSize = newTable.userData.bSize;
                    // Если это не Vector3 (проверяем по типу), создаём Vector3
                    if (!(bSize instanceof THREE.Vector3)) {
                        newTable.userData.bSize = new THREE.Vector3(bSize.x, bSize.y, bSize.z);
                    }
                }
                const changeable_painted_metal_material = newTable.userData.colors.changeable_painted_metal_material;
                const changeable_kromka_material = newTable.userData.colors.changeable_kromka_material;

                // Новое имя: name из userData + id объекта
                newTable.name = `${userData.name}__${newTable.id}`;
                if (meshes && Array.isArray(meshes)) {
                    meshes.forEach((meshData) => {
                        const mesh = newTable.getObjectByName(meshData.name);
                        if (mesh && mesh.isMesh) {
                            mesh.position.set(meshData.position.x, meshData.position.y, meshData.position.z);
                            if (mesh.morphTargetInfluences) mesh.morphTargetInfluences[0] = 0;
                        }
                    });
                }
                servObj.scene.add(newTable);
                // servObj.allTableInRoom.push(newTable);
                servObj.building._all.push(newTable);
                servObj.building._objects.push(newTable);

                // Добавляем элементы (children)

                if (elements.length) {
                    for (const el of elements) {
                        const { position, rotation, userData, name, scale } = el;
                        const { visibleChildren } = userData;

                        // Ищем элемент по имени в нужном массиве
                        const arrName = userData.allFolderName;
                        const child = servObj[arrName]?.find((obj) => obj.name === name);
                        if (!child) {
                            console.warn("Элемент не найден:", name, arrName);
                            continue;
                        }
                        const newChild = cloneObject(child);

                        if (el.name.includes("levaya_petlya")) {
                            console.log({ newChild, el });
                        }
                        // Применяем позицию, вращение, userData
                        newChild.position.set(position.x, position.y, position.z);
                        newChild.rotation.set(rotation.x, rotation.y, rotation.z);
                        if (scale) {
                            newChild.scale.set(scale.x, scale.y, scale.z);
                        }
                        newChild.userData = {
                            ...newChild.userData,
                            ...userData,
                        };
                        // Добавляем в children стола
                        newTable.add(newChild);
                        // Устанавливаем видимость
                        setVis(newTable, true);
                        setTimeout(() => {
                            showHideChildrenByNames(newChild, getHiddenObjArr(newChild.name), false);

                            newChild.traverse((subChild) => {
                                if (subChild?.isGroup) {
                                    showHideChildrenByNames(newChild, getHiddenObjArr(subChild.name), false);
                                }
                            });
                        }, 100);
                        setTimeout(() => {}, 100);
                        setTimeout(() => {
                            if (visibleChildren && visibleChildren.length) {
                                showHideChildrenByNames(newChild, visibleChildren, true);

                                newChild.traverse((subChild) => {
                                    if (subChild?.isGroup) {
                                        const hiddenArr = getHiddenObjArr(subChild.name)?.filter((item) => {
                                            return !visibleChildren.some((v) => v.includes(item));
                                        });

                                        showHideChildrenByNames(newChild, hiddenArr, false);
                                    }
                                });
                            }
                        }, 200);
                    }
                } else {
                    setVis(newTable, true);
                }

                setTimeout(() => {
                    showHideChildrenByNames(newTable, getHiddenObjArr(newTable.name), false);
                }, 100);

                if (userData.visibleChildren && userData.visibleChildren.length) {
                    setTimeout(() => {
                        showHideChildrenByNames(newTable, userData.visibleChildren, true);
                    }, 100);
                }

                // КОСТЫЛЬ: Для стола СМК не скрываем разделители, т.к. это не обычный children, а отдельный элемент Group (он либо есть, либо его нет изначально)
                if (newTable.name.includes("smk__osnovanie")) {
                    setTimeout(() => {
                        showHideChildrenByNames(newTable, ["razdelitel"], true);
                    }, 100);
                }

                // Применяем сохраненный ранее цвет объекта
                changeMaterialColor(newTable, "changeable_painted_metal_material", changeable_painted_metal_material);
                changeMaterialColor(newTable, "changeable_kromka_material", changeable_kromka_material);
            }
        }
        // Открываем главное меню
        openCorrectSideMenu("main_btns");
        addInRoomBtn.classList.add("hide");
        animateDoorsBtnWrap.classList.add("hide");
        servObj.isEditMode = false;
        servObj.isRedactorMode = false;
        deleteObj(servObj.redactorModeObject);
        setCameraOnRoom();
        applyRoomLighting();
    }
    servObj.guideLines.hideLines();
    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
};
const setRoomSizes = (objSizes) => {
    if (!objSizes || typeof objSizes !== "object") {
        console.error("Ошибка: передан неверный объект размеров");
        return;
    }
    const { width, depth, height } = objSizes;
    Object.assign(servObj.roomSize, {
        width: depth,
        length: width,
        height,
    });
    Object.assign(servObj.building, objSizes);
    const roomSizesContainer = document.querySelector(".room_sizes");
    if (!roomSizesContainer) {
        return;
    }
    const setInputValue = (selector, value) => {
        const input = roomSizesContainer.querySelector(selector);
        if (!input) {
            console.error(`Ошибка: не найден input по селектору "${selector}"`);
            return;
        }
        input.value = value ?? "";
    };
    setInputValue(".length_box input", width);
    setInputValue(".width_box input", depth);
    setInputValue(".heigth_box input", height);
};
